import React from "react";
import PropTypes from "prop-types";

const ConfirmationModal = ({ isOpen, message, onConfirm, onCancel }) => {
  if (!isOpen) return null;
  return (
    <div className="confirmation-modal" data-testid="confirmation-modal">
      <div className="modal-backdrop fade in"></div>
      <div className="modal fade in" style={{ display: 'block', position: 'fixed', zIndex: 9999 }}>
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Confirm Action</h5>
              <button type="button" className="close" aria-label="close" onClick={onCancel} data-testid="confirmation-modal-close-button">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="confirmation-modal-message" data-testid="confirmation-modal-message">{message}</div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-danger" onClick={onConfirm} data-testid="confirmation-modal-confirm-button">Yes</button>
              <button type="button" className="btn btn-secondary" onClick={onCancel} data-testid="confirmation-modal-cancel-button">No</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

ConfirmationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default ConfirmationModal;
